import axios from "axios";
import userManager from "@/plumbing/auth";

export function configureUnauthorizedInterceptor() {
  axios.interceptors.response.use(async response => {
    if (response?.status === 401) {
      await userManager.signinRedirect();
    }
    return response;
  });
}
